const demoPaymentMethods = [
  {
    id: "pm-bank-1",
    type: "bank",
    bankName: "Demo Savings Bank",
    accountHolderName: "Demo User",
    accountNumber: "1234567890",
    sortCode: "044",
    routingNumber: "110000000",
    accountType: "checking",
    isDefault: true,
  },
  {
    id: "pm-bank-2",
    type: "bank",
    bankName: "City Credit Union",
    accountHolderName: "Demo User",
    accountNumber: "9876543210",
    sortCode: "058",
    routingNumber: "120000000",
    accountType: "savings",
    isDefault: false,
  },
  {
    id: "pm-mm-1",
    type: "mobile_money",
    provider: "Opay",
    phoneNumber: "+2348012345678",
    isDefault: false,
  },
];

export async function handle(path: string, _init?: RequestInit) {
  if (/^\/(api\/)?payment-methods(\/|$)/.test(path)) {
    return { paymentMethods: demoPaymentMethods };
  }

  return null;
}
